import { formatMoney, LOCALES } from "@batiflow/i18n";
import { money } from "@batiflow/domain-fiscal";
import { useTranslation } from "react-i18next";
function useLocale() {
  const { i18n } = useTranslation("ui");
  const language = i18n.resolvedLanguage ?? i18n.language;
  return LOCALES.find((l) => l === language) ?? "fr";
}
const NBSP = String.fromCharCode(160);
function currencyLabel(currency, locale) {
  const formatted = formatMoney(money(0n, currency), locale);
  return formatted.split(NBSP).pop() ?? currency;
}
export {
  currencyLabel,
  useLocale
};
//# sourceMappingURL=use-locale.js.map